import { render, staticRenderFns } from "./DeptRoleUserModal.vue?vue&type=template&id=fcf0cb92&scoped=true&"
import script from "./DeptRoleUserModal.vue?vue&type=script&lang=js&"
export * from "./DeptRoleUserModal.vue?vue&type=script&lang=js&"
import style0 from "./DeptRoleUserModal.vue?vue&type=style&index=0&id=fcf0cb92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcf0cb92",
  null
  
)

export default component.exports